import { connect } from 'react-redux';

import { IReduxState } from '../../types/redux';
import { RegionalBackground, IRegionalBackgroundProps } from '../../components/RegionalBackground';

type TRegionalBackgroundStateProps = Pick<IRegionalBackgroundProps, 'jsonQuery'>;

export function mapStateToProps(state: IReduxState): TRegionalBackgroundStateProps {
  return {
    jsonQuery: state.filters.jsonQuery,
  };
}

export const RegionalBackgroundContainer = connect(mapStateToProps)(RegionalBackground);
